<template>
    <b-container id="all_jobs" class="section">
        <b-row align-v="center">
            <b-col cols="12" lg="9">
                <div class="subsection">
                    <h2 class="section_title">
                        {{ jobsLength }}
                    </h2>
                </div>
            </b-col>

            <b-col cols="12" lg="3" />
        </b-row>

        <b-row align-v="start">
            <b-col cols="12" lg="9">
                <template v-if="$store.state.jobs.jobs.length > 0">
                    <div class="subsection">
                        <div id="jobs">
                            <Job v-for="(job, i) in $store.state.jobs.jobs" :key="i" :job="job" />
                        </div>
                    </div>

                    <div class="subsection">
                        <b-row align-v="center">
                            <b-col cols="12" lg="6">
                                <div class="more">
                                    <b-btn
                                        :disabled="$store.state.jobs.params.page >= $store.getters['jobs/getPages']"
                                        class="more_button button_white"
                                        @click="$store.dispatch('jobs/moreJobsPage')"
                                    >
                                        {{ $t("jobs.showMore") }}
                                    </b-btn>
                                </div>
                            </b-col>

                            <b-col class="d-none d-lg-block" cols="12" lg="6">
                                <b-pagination
                                    v-model="$store.state.jobs.params.page"
                                    :hide-ellipsis="true"
                                    :hide-goto-end-buttons="true"
                                    :per-page="$store.state.jobs.params.limit"
                                    :total-rows="$store.state.jobs.total"
                                    class="pages_list"
                                    @change="
                                        value =>
                                            $store.dispatch('jobs/setJobsPage', {
                                                value,
                                            })
                                    "
                                />
                            </b-col>
                        </b-row>
                    </div>
                </template>
            </b-col>

            <b-col cols="12" lg="3">
                <div class="subsection">
                    <div class="view">
                        <div id="window" :class="$store.state.filter ? 'opened' : 'closed'" class="window_fixed">
                            <div class="window_head d-lg-none">
                                <h3 class="window_title" @click="$store.dispatch('closeFilter')">Filtry</h3>
                            </div>

                            <div class="window_body">
                                <div id="filters">
                                    <div v-for="(filter, i) in $store.state.enum.filters" :key="i" class="filter">
                                        <h4 class="filter_title">{{ filter.label }}:</h4>

                                        <b-nav class="subfilters_list">
                                            <b-nav-item
                                                v-for="(value, j) in filter.values"
                                                :key="j"
                                                :active="$store.state.jobs.params.filters[filter.name] === value.value"
                                                @click="
                                                    $store.dispatch('jobs/setJobsFilter', {
                                                        filter: filter.name,
                                                        value: value.value,
                                                    })
                                                "
                                            >
                                                {{ value.label }}
                                            </b-nav-item>
                                        </b-nav>
                                    </div>
                                </div>
                            </div>

                            <div class="window_foot d-lg-none">
                                <p>
                                    {{ filtersLength }}
                                </p>

                                <b-btn class="filter_button button_blue" @click="$store.dispatch('closeFilter')">
                                    {{ $t("jobs.filters.backToAds") }}
                                </b-btn>

                                <b-btn
                                    class="filter_button button_link"
                                    @click="$store.dispatch('jobs/clearJobsFilters')"
                                >
                                    {{ $t("jobs.filters.clear") }}
                                </b-btn>
                            </div>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import Job from "~/components/Jobs/Job";

export default {
    components: {
        Job,
    },
    computed: {
        jobsLength() {
            const jobCount = this.$store.state.jobs.total;
            return this.$tc("jobs.search.jobs", jobCount);
        },
        filtersLength() {
            const counts = Object.keys(this.$store.state.jobs.params.filters).length;
            return this.$tc("jobs.filters.appliedFilters", counts);
        },
    },
};
</script>
